import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  Grid,
  LinearProgress,
  Chip,
  Button,
  Icon
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { getStoreCategoriesApi, getStoreCategoriesTreeApi } from 'api';
import { changeProductCategories } from 'redux/actions/products';
import { changeProductCategoryStatus } from 'redux/actions/categories';
import AddCategoryModal from './addCategoryModal';


const CustomChip = makeStyles({
  root: {
    height: '24px'
  }
});

const ProductCategories = () => {
  const classes = CustomChip();
  const dispatch = useDispatch();
  const [openAddCategoryModel, setOpenAddCategoryModal] = useState(false);
  const {
    storeCategoriesWithActiveNavLevel,
    storeCategoriesTree,
    isNewCategory,
    loadingCategories,
    loadingSaveStoreCategories,
    loadingCreateStoreCategory,
    errorCategories
  } = useSelector((state) => state.categories);
  const { editable_store_product, selectedProductCategoriesIds} = useSelector((state) => state.products);

  useEffect(() => {
    if (storeCategoriesWithActiveNavLevel.length === 0 || isNewCategory) {
      getStoreCategoriesApi({dispatch, checkStoreType: false});
    }

    if (storeCategoriesTree.length === 0 || isNewCategory) {
      getStoreCategoriesTreeApi({dispatch});
    }
  }, []);

  const handleSelectCategories = (category) => {
    if (category && !selectedProductCategoriesIds.includes(String(category.id))) {
      dispatch(changeProductCategoryStatus(category.id));
      dispatch(changeProductCategories('select-option', category.id, editable_store_product));
    }
  };

  const handleDeleteCategory = (id) => {
    dispatch(changeProductCategories('remove-option', Number(id), editable_store_product));
  };

  return (
    <Grid container spacing={3} className="m-4">
      <Grid item xs={12} md={3}>
        Product in Categories
      </Grid>
      <Grid item xs={12} md={9}>
        {loadingCategories && !loadingSaveStoreCategories && <> <div>Preparing Categories...</div><LinearProgress /></>}
        {loadingCategories && loadingSaveStoreCategories && <> <div>Wait, while we&apos;re creating New Category...</div><LinearProgress /></>}
        {!loadingCategories && errorCategories && <div>Can&apos;t fetch categories data</div>}
        {!loadingCategories && !loadingSaveStoreCategories && storeCategoriesWithActiveNavLevel.length !== 0 &&
          <>
            <div className="flex items-center">
              <Button
                color="primary"
                variant="contained"
                className="rounded mb-4"
                onClick={() => setOpenAddCategoryModal(true)}
              >
                <Icon>add</Icon>
                Add Product To Category
              </Button>

              {!!storeCategoriesTree.length && openAddCategoryModel &&
                <AddCategoryModal
                  itemName={editable_store_product.name}
                  open={openAddCategoryModel}
                  setOpen={setOpenAddCategoryModal}
                  onConfirm={handleSelectCategories}
                />}
            </div>
            {selectedProductCategoriesIds?.map((id) => {
              const nameWithPath = storeCategoriesWithActiveNavLevel?.find((category) => category.id == id)?.nameWithPath;
              return (
                <Chip
                  connector={<CustomChip />}
                  key={id}
                  label={nameWithPath}
                  onDelete={() => handleDeleteCategory(id)}
                  className={clsx({
                    [classes.root]: true,
                    'm-1 p-2 text-14': true,
                    //TODO: temporary hide categories that not present in user store but linked to product on master catalog
                    'hidden': !nameWithPath
                  })}
                />
              );
            })}
          </>
        }
      </Grid>
      <BackdropCircular loading={loadingCreateStoreCategory} />
    </Grid>

  );
};

export default ProductCategories;
